exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-store-form {\n  width: 100%;\n  padding: 32px;\n}\n.create-store-form__form .ant-form-item {\n  width: 582px;\n}\n.upload-store-photo {\n  width: 212px !important;\n}\n.create-store-divider {\n  color: #a7a8aa;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n}\n@media (max-width: 768px) {\n  .button-create-store {\n    font-size: 12px !important;\n    width: 78px !important;\n    height: 38px !important;\n  }\n}\n@media (min-width: 1024px) {\n  .button-create-store {\n    width: 191px !important;\n    height: 74px !important;\n  }\n}\n.input-id-lotus {\n  width: 100px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/CreateStore/components/CreateStoreForm/CreateStoreForm.less
// module id = 1032
// module chunks = 0